// Generated on 2025-12-23T21:59:23.233Z
// This file contains preloaded vehicles models data from the API
// Do not edit manually - use 'npm run generate:vehicles-models-data' to regenerate

export const preloadedVehiclesModels: any = [
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "61316"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "60369"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "55138"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "46286"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "40964"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "19450"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "16739"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "14938"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "14326"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "12799"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "12648"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "11443"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "10522"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "8828"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "8373"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "7130"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "7036"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "6908"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "6770"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "6722"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "5702"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "5630"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "5494"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "5197"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "5142"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "5129"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "5066"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "4685"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "4572"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "4495"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "4090"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "4068"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "3893"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "3756"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "3499"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "3201"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "2883"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "2800"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "2783"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "2695"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "2600"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "2496"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "2393"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "2380"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "2289"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "2101"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "1920"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "1896"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "1857"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "1830"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "1811"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "1760"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "1751"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "1699"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "1696"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "1689"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "1688"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "1558"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "1526"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "1437"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "1318"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "1274"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "1251"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "1237"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "1213"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "1188"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "1180"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "1172"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "1160"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "1154"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "1138"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "1133"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "1087"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "1018"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "1004"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "1000"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "995"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "993"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "979"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "943"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "939"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "933"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "922"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "917"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "911"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "903"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "876"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "859"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "856"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "856"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "835"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "823"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "822"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "813"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "798"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "767"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "724"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "723"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "709"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "657"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "652"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "637"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "629"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "623"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "606"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "551"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "547"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "540"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "513"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "466"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "466"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "463"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "461"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "460"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "450"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "444"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "441"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "440"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "436"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "433"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "428"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "425"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "406"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "401"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "395"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "391"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "383"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "378"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "367"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "363"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "362"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "348"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "347"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "343"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "327"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "324"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "323"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "322"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "321"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "310"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "300"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "297"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "293"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "292"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "288"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "275"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "271"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "267"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "259"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "250"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "240"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "235"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "232"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "231"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "230"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "229"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "229"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "229"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "222"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "221"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "217"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "217"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "216"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "213"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "210"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "205"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "201"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "197"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "192"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "190"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "189"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "187"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "185"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "182"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "179"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "177"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "176"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "176"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "176"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "171"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "169"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "169"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "167"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "164"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "162"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "160"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "159"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "157"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "150"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "149"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "148"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "147"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "144"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "143"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "139"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "139"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "137"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "137"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "134"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "130"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "130"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "129"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "127"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "123"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "122"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "121"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "118"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "116"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "116"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "114"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "114"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "113"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "107"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "107"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "104"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "103"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "103"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "103"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "102"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "101"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "100"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "100"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "98"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "97"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "95"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "95"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "94"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "89"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "85"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "85"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "84"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "84"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "83"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "81"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "80"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "79"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "78"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "77"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "77"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "77"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "77"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "74"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "74"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "74"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "73"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "73"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "72"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "72"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "72"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "72"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "71"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "69"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "68"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "68"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "66"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "64"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "63"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "62"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "62"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "61"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "60"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "59"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "57"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "55"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "54"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "54"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "53"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "52"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "51"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "50"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "50"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "49"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "48"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "47"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "47"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "46"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "46"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "46"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "45"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "45"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "44"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "44"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "43"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "43"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "42"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "41"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "41"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "41"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "40"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "40"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "39"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "39"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "39"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "38"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "38"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "37"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "36"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "36"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "35"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "35"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "35"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "35"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "35"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "34"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "34"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "34"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "34"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "33"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "33"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "33"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "33"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "33"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "33"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "33"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "33"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "33"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "32"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "31"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "31"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "30"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "30"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "30"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "29"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "29"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "29"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "28"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "28"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "28"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "28"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "28"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "27"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "27"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "27"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "27"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "26"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "26"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "25"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "25"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "25"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "25"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "24"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "24"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "24"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "24"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "24"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "23"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "23"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "23"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "23"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "23"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "22"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "22"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "22"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "22"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "22"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "22"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "21"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "21"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "21"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "20"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "20"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "20"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "19"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "19"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "19"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "18"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "18"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "18"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "18"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "18"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "18"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "17"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "17"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "16"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "16"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "15"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "15"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "15"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "15"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "15"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "15"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "15"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "14"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "14"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "14"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "14"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "14"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "14"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "14"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "13"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "13"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "13"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "13"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "12"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "12"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "12"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "12"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "12"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "12"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "11"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "11"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "11"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "11"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "11"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "10"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "10"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "10"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "9"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "9"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "8"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "8"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "7"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "7"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "7"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "7"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "7"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "6"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "6"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "6"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "6"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "5"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "4"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "4"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "4"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "4"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "3"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "3"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "3"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "3"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "3"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "2"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "1"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "1"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "1"
  }
];

export default preloadedVehiclesModels;
